export const BACKEND_URL = "http://localhost:5000";
